import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class RecSessionService {
    static async getRecSessionsAsync(projectId) {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/${projectId}/rec-session`);
        return response.items || response || [];
    }

    static async getRecSessionAsync(projectId, recSessionId) {
        return await NetworkService.getAsync(`${API_BASE_URL}/projects/${projectId}/rec-session/${recSessionId}`);
    }

    static async createRecSessionAsync(projectId, body) {
        return await NetworkService.postAsync(`${API_BASE_URL}/projects/${projectId}/rec-session`, body);
    }

    /** Replaces the whole session: core layer, aux layers and their tracks. */
    static async updateRecSessionAsync(projectId, recSessionId, body) {
        return await NetworkService.putAsync(`${API_BASE_URL}/projects/${projectId}/rec-session/${recSessionId}`, body);
    }

    static async deleteRecSessionAsync(projectId, recSessionId) {
        return await NetworkService.deleteAsync(`${API_BASE_URL}/projects/${projectId}/rec-session/${recSessionId}`);
    }

    /** `items[].layer_id` moves a track to another layer of the session. */
    static async bulkUpdateTracksAsync(projectId, recSessionId, body) {
        return await NetworkService.postAsync(`${API_BASE_URL}/projects/${projectId}/rec-session/${recSessionId}/track/bulk`, body);
    }

    static async uploadTrackAsync(projectId, recSessionId, formData, queryParams) {
        return await NetworkService.postMultiPartAsync(
            `${API_BASE_URL}/projects/${projectId}/rec-session/${recSessionId}/track`,
            formData,
            queryParams
        );
    }
}
